import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { money } from '@/components/ewayBill/shared';

const rate = (i) => (i.igst_rate ? `IGST ${i.igst_rate}%` : `CGST ${i.cgst_rate}% + SGST ${i.sgst_rate}%`);

/** Items + tax totals of an e-way bill (from WMS / ERP — read only). */
export const ItemsTable = ({ items, totals }) => (
  <div className="rounded-lg border border-gray-200 bg-white">
    <div className="max-h-[360px] overflow-auto [&>div]:overflow-visible">
      <Table data-testid="ewb-items">
        <TableHeader className="sticky top-0 z-10 bg-white shadow-[0_1px_0_#e5e7eb]"><TableRow>{['Product', 'HSN', 'Qty', 'Rate', 'Taxable value', 'Tax'].map((h) => <TableHead key={h}>{h}</TableHead>)}</TableRow></TableHeader>
        <TableBody>
          {items.map((i, n) => (
            <TableRow key={n} data-testid={`ewb-item-${n}`}>
              <TableCell>
                <div className="font-medium font-mono" data-testid={`ewb-item-${n}-name`}>{i.name}</div>
                {i.description && <div className="text-xs text-gray-500">{i.description}</div>}
                {i.note && <div className="text-[11px] text-teal-700" data-testid={`ewb-item-${n}-note`}>{i.note}</div>}
              </TableCell>
              <TableCell className="font-mono" data-testid={`ewb-item-${n}-hsn`}>{i.hsn}</TableCell>
              <TableCell className="tabular-nums">{i.qty} {i.unit}</TableCell>
              <TableCell className="tabular-nums" data-testid={`ewb-item-${n}-rate`}>{i.rate != null ? money(i.rate) : '—'}</TableCell>
              <TableCell className="tabular-nums" data-testid={`ewb-item-${n}-value`}>{money(i.taxable_value)}</TableCell>
              <TableCell className="text-xs" data-testid={`ewb-item-${n}-tax`}>{rate(i)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
    <div className="flex flex-wrap gap-x-6 gap-y-1 border-t px-4 py-2 text-sm" data-testid="ewb-totals">
      <span>Taxable <b className="tabular-nums">{money(totals.taxable)}</b></span>
      {totals.cgst > 0 && <span>CGST <b className="tabular-nums">{money(totals.cgst)}</b></span>}
      {totals.sgst > 0 && <span>SGST <b className="tabular-nums">{money(totals.sgst)}</b></span>}
      {totals.igst > 0 && <span>IGST <b className="tabular-nums">{money(totals.igst)}</b></span>}
      {!!totals.other && <span data-testid="ewb-round-off">Round off <b className="tabular-nums">{money(totals.other)}</b></span>}
      <span className="ml-auto">Invoice value <b className="tabular-nums text-base" data-testid="ewb-invoice-value">{money(totals.invoice_value)}</b></span>
    </div>
  </div>
);

export default ItemsTable;
